export default "__VITE_ASSET__C0ygo3L$__"